import React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import GridRightFilters from './GridRightFilters';
import CloseIcon from '@mui/icons-material/Close';
import { RightFilterDrawerProps } from 'types/IRightFilterDrawerProps';
import { useTranslation } from "react-i18next";
import { useAtom } from 'jotai';
import { sidebarFilterCountAtom } from 'Atoms/WorkAssignmentGridAtoms';
import { useResetRightFilter } from 'utilities/ResetFilters';

const RightFilterDrawer: React.FC<RightFilterDrawerProps> = ({
  anchor,
  open,
  onClose,
  onOpen
}) => {
  const [t, ] = useTranslation();
  const resetRightFilter = useResetRightFilter();
  const [filterCount] = useAtom(sidebarFilterCountAtom);

  return (
    <SwipeableDrawer anchor={anchor} open={open} onClose={onClose} onOpen={onOpen}>
      <Box sx={{ width: 350 }} role="presentation">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
          <Button onClick={resetRightFilter} disabled={filterCount === 0} variant="text">
            {t("ClearAllText")}
          </Button>
          <Button variant="text" startIcon={<CloseIcon />} onClick={onClose}>
            {t("CloseText")}
          </Button>
        </Box>
        <GridRightFilters></GridRightFilters>        
      </Box>
    </SwipeableDrawer>
  );
};

export default RightFilterDrawer;
